import { createFileRoute } from '@tanstack/react-router';
import { ImportsRouteView } from '@/pages/workspaces/imports/routing';
import { LastWorkspaceResolver } from './-components';
import { validateWizardSearch } from './-import-wizard-search';
import { ImportFieldsPage } from './-route-pages';

/** No `appBundle`: this URL has no `journeys` segment for the resolver to rebuild from. */
function ImportFieldsRoute() {
  return (
    <LastWorkspaceResolver>
      <ImportsRouteView>
        <ImportFieldsPage />
      </ImportsRouteView>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/imports/$importId/setup/fields')({
  validateSearch: validateWizardSearch,
  component: ImportFieldsRoute,
});
